const IMAGE_URL = "/images/Tilley_logo.svg";
const POWERED_BY_TEXT = "Powered by Tilley";
const TILLEY_URL = "www.FarmTilley.com";

const Letterhead = () => {
  return (
    <div className="letterhead only-print">
      <img className="letterhead__logo" src={IMAGE_URL} alt="Tilley Logo" />
      <div className="letterhead__text">{POWERED_BY_TEXT}</div>
      <div className="letterhead__url">{TILLEY_URL}</div>
    </div>
  );
};

export default Letterhead;
